/* =========================================================
   EYESHELLS: Split engo-scripts.js -> engo-collection.js
   - Collection/Search UX (sort, grid, filters, drawer, etc.)
   ========================================================= */

(function($){
  $(function(){
    "use strict";

    function sortLayout() {
        var isCollectionOrSearchPage = !!document.querySelector('body.template-collection, body.template-search');
        /*
          ES 947:
          Collection/search grid columns are owned by es-collection-cols-persist.js
          (with an early <html class="es-cols-*"> paint hint in theme.liquid).
          Running the legacy jQuery grid mutator on these pages can bind duplicate
          view-as logic and rewrite grid classes after first paint, causing tiny card jiggle.
          Keep the legacy handler available only for non collection/search contexts.
        */
        if (isCollectionOrSearchPage) {
          return;
        }

        var RESIZE_NS = '.eyeshellsCollectionLayout';
        var SIZE_CLASS_RE = /\bsize_([1-5])\b/;
        var GRID_SIZE_RE = /\bsize_[1-5]\b/g;
        var GRID_ITEM_CLASSES = 'col-lg-1 col-lg-2 col-lg-3 col-lg-4 col-lg-5 col-lg-6 col-lg-7 col-lg-8 col-lg-9 col-lg-10 col-lg-11 col-lg-12 col-lg-2dot4 col-md-1 col-md-2 col-md-3 col-md-4 col-md-5 col-md-6 col-md-7 col-md-8 col-md-9 col-md-10 col-md-11 col-md-12 col-12 col-6';

        function getViewportMode() {
          var w = window.innerWidth || document.documentElement.clientWidth || $(window).width() || 0;
          if (w < 768) return 'mobile';
          if (w < 1200) return 'tablet';
          return 'desktop';
        }

        function isTabletPortrait() {
          if (getViewportMode() !== 'tablet') return false;
          if (window.matchMedia) {
            try { return window.matchMedia('(orientation: portrait)').matches; } catch (e) {}
          }
          return (window.innerHeight || document.documentElement.clientHeight || 0) >= (window.innerWidth || document.documentElement.clientWidth || 0);
        }

        function allowedColsForViewport() {
          var mode = getViewportMode();
          if (mode === 'mobile') return [1, 2];
          if (mode === 'tablet') return isTabletPortrait() ? [2, 3] : [3, 4];
          return [3, 4, 5];
        }

        function defaultColsForViewport() {
          var mode = getViewportMode();
          if (mode === 'mobile') return 2;
          if (mode === 'tablet') return isTabletPortrait() ? 3 : 4;
          return 4;
        }

        function getColsFromClassName(className) {
          var m = (className || '').match(SIZE_CLASS_RE);
          return m ? parseInt(m[1], 10) : null;
        }

        function normalizeCols(cols) {
          cols = parseInt(cols, 10);
          if (!cols) return null;

          var mode = getViewportMode();
          if (mode === 'mobile') {
            return (cols === 1 || cols === 2) ? cols : 2;
          }
          if (mode === 'tablet') {
            var allowed = allowedColsForViewport();
            return allowed.indexOf(cols) !== -1 ? cols : defaultColsForViewport();
          }
          if (cols < 3) return 4;
          if (cols > 5) return 5;
          return cols;
        }

        function detectCurrentCols() {
          var $item = $('.template-collection .product-grid-view .js_size_prod').first();
          if (!$item.length) return null;
          if ($item.hasClass('col-12')) return 1;
          if ($item.hasClass('col-lg-2dot4')) return 5;
          if ($item.hasClass('col-md-3') || $item.hasClass('col-lg-3')) return 4;
          if ($item.hasClass('col-md-4') || $item.hasClass('col-lg-4')) return 3;
          if ($item.hasClass('col-6')) return 2;
          return null;
        }

        function updateButtonVisibility() {
          var allowed = allowedColsForViewport();
          var mode = getViewportMode();

          $('.change_collum.es-desktop-viewas').each(function(){
            $(this).toggleClass('d-none', mode === 'mobile');
          });

          $('.prod_per a').each(function(){
            var $btn = $(this);
            var cols = getColsFromClassName($btn.attr('class'));
            var visible = allowed.indexOf(cols) !== -1;
            $btn.toggleClass('d-none', !visible);
            $btn.attr('aria-hidden', visible ? 'false' : 'true');
            $btn.attr('tabindex', visible ? '0' : '-1');
          });
        }

        function applyGridCols(cols) {
          cols = normalizeCols(cols);
          if (!cols) cols = defaultColsForViewport();

          $('.js_size_prod').removeClass(GRID_ITEM_CLASSES);
          if (cols === 1) {
            $('.js_size_prod').addClass('col-12');
          } else if (cols === 2) {
            $('.js_size_prod').addClass('col-6');
          } else if (cols === 3) {
            $('.js_size_prod').addClass('col-md-4');
          } else if (cols === 4) {
            $('.js_size_prod').addClass('col-md-3');
          } else if (cols === 5) {
            $('.js_size_prod').addClass('col-lg-2dot4');
          }

          $('.prod_per a').removeClass('active');
          $('.prod_per a.size_' + cols).not('.d-none').addClass('active');
          $('.collection_prod').removeClass('size_1 size_2 size_3 size_4 size_5').addClass('size_' + cols);
        }

        function syncButtonsForViewport() {
          updateButtonVisibility();

          var activeCols = getColsFromClassName($('.prod_per a.active').not('.d-none').first().attr('class'));
          var normalizedActive = normalizeCols(activeCols);
          if (!normalizedActive) {
            var htmlMatch = (document.documentElement.className || '').match(/\bes-cols-([1-5])\b/);
            normalizedActive = normalizeCols(htmlMatch && htmlMatch[1]);
          }
          if (!normalizedActive) {
            normalizedActive = normalizeCols(detectCurrentCols()) || defaultColsForViewport();
          }

          applyGridCols(normalizedActive);
        }

        $('.prod_per a')
          .off('click.eyeshellsCollectionLayout')
          .on('click.eyeshellsCollectionLayout', function(e){
            e.preventDefault();
            applyGridCols(getColsFromClassName($(this).attr('class')));
          });

        syncButtonsForViewport();
        $(window).off('resize' + RESIZE_NS).on('resize' + RESIZE_NS, function(){
          syncButtonsForViewport();
        });
      }

    function changeProdListGrid(){
        $('.prod_grid').off('click.eyeshellsProdGrid').on('click.eyeshellsProdGrid', function(){
          $('.product-grid-view').addClass('active');
          $('.product-list-view').removeClass('active');
          $(this).addClass('active');
          $('.prod_list').removeClass('active');
          $('.prod_per').removeClass('active');

        });
        $('.prod_list').off('click.eyeshellsProdList').on('click.eyeshellsProdList', function(){
          $('.product-grid-view').removeClass('active');
          $('.product-list-view').addClass('active');
          $(this).addClass('active');
          $('.prod_grid').removeClass('active');
          $('.prod_per').addClass('active');
        });
      }
    
    function FilterPushLeft(){
        $(document)
          .off('click.eyeshellsFilter')
          .on('click.eyeshellsFilter', '.js_filter', function(e){
            e.preventDefault();
    
            $('.filter-to-left').toggleClass('active');
            $('.overlay-filter').toggleClass('active', $('.filter-to-left').hasClass('active'));
          })
          .on('click.eyeshellsFilter', '.close_filter', function(e){
            e.preventDefault();
            $('.filter-to-left').removeClass('active');
            $('.overlay-filter').removeClass('active');
          })
          .on('click.eyeshellsFilter', '.overlay-filter', function(e){
            if (!$('.filter-to-left').hasClass('active')) return;
            e.preventDefault();
            $('.filter-to-left').removeClass('active');
            $('.overlay-filter').removeClass('active');
          });
      }
    
    function js_draw_filter(){
        $(document)
          .off('click.eyeshellsDrawFilter', '.js-draw-filter-btn, .js-draw-filter-open')
          .on('click.eyeshellsDrawFilter', '.js-draw-filter-btn, .js-draw-filter-open', function(){
            var $trigger = $(this);
            var isOpen = $trigger.hasClass('js-draw-filter-open');
            $trigger.toggleClass('js-draw-filter-open', !isOpen);
            $trigger.toggleClass('js-draw-filter-btn', isOpen);
            $('.js-draw-filter').toggleClass('draw_filter', isOpen).toggleClass('col-lg-3', !isOpen);
            $('.js-draw-filter-2').toggleClass('col-lg-12', isOpen).toggleClass('col-lg-9', !isOpen);
          });
      }
    
    function checkclickcol(){
        $('.js-check-click-col').off('click.eyeshellsCheckCol').on('click.eyeshellsCheckCol', function(){
          $(this).toggleClass('active');
        });
      }
    
    function listcollection(){
        var $list = $('.js_list_col');
        if (!$list.length || !$list.slick || $list.hasClass('slick-initialized')) return;
        $list.slick({
          dots: false,
          arrows:true,
          infinite: false,
          speed: 300,
          autoplay:false,
          slidesToShow: 5,
          slidesToScroll: 1,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left"></i> </button>',
          nextArrow:'<button type="button" class="next-slide"> <i class="fa-solid fa-angle-right"></i></button>',
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
              }
            },
    
            {
              breakpoint: 575,
              settings: {
                slidesToShow: 1,
              }
            }
          ]
        });
    
      }
    
    function jsDScollectionV1(){
        var $collection = $('.js_ds_collectionv1');
        if (!$collection.length || !$collection.slick || $collection.hasClass('slick-initialized')) return;
        $collection.slick({
          dots: false,
          arrows:false,
          infinite: false,
          speed: 300,
          autoplay:false,
          slidesToShow: 3,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                dots: false, 
                arrows: false
              }
            }
          ]
        });
    
      }
    
    function jscolbreacrumb(){
        var $breadcrumb = $('.js_col_breacrumb');
        if (!$breadcrumb.length || !$breadcrumb.slick || $breadcrumb.hasClass('slick-initialized')) return;
        $breadcrumb.slick({
          dots: false,
          arrows:true,
          infinite: false,
          speed: 300,
          autoplay:false,
          slidesToShow: 5,
          slidesToScroll: 2,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left"></i></button>',
          nextArrow:'<button type="button" class="next-slide"><i class="fa-solid fa-angle-right"></i></button>',
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 4
              }
            },
            {
              breakpoint: 800,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2
              }
            }
          ]
        });
    
      }

    function runIf(sel, fn){ if (!sel) { try{fn();}catch(e){} return; } if ($(sel).length) { try{fn();}catch(e){} } }
    runIf(".prod_per a", sortLayout);
    runIf(".prod_grid", changeProdListGrid);
    runIf(".js_filter", FilterPushLeft);
    runIf(".js-draw-filter-btn", js_draw_filter);
    runIf(".js-check-click-col", checkclickcol);
    runIf(".js_list_col", listcollection);
    runIf(".js_ds_collectionv1", jsDScollectionV1);
    runIf(".js_col_breacrumb", jscolbreacrumb);
  });
})(window.jQuery);
